module.exports = __webpack_public_path__ + "img/main-logo.4ee78438.jpg";